export default __webpack_public_path__ + "static/media/banner6en.477e12e6.png";